var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{staticClass:"_z-index-1000",attrs:{"value":_vm.active}},[_c('div',{staticClass:"lds-ring"},[_c('div'),_c('div'),_c('div'),_c('div')])])}
var staticRenderFns = []

export { render, staticRenderFns }